import { UnderlineIcon } from "components/common/Icons/UnderlineIcon";
import { useUnderline } from "../../../BottomMenu/Content/TextBoxSettings/Options/FontStyle/Content/Underline/useUnderline";
import { useFindTextBox } from "../useFindTextBox";

interface UnderlineProps {
    textBoxId: string;
}

export const Underline = ({ textBoxId }: UnderlineProps) => {
    const { textBox } = useFindTextBox(textBoxId);
    const {isActive, handleClick} = useUnderline(textBox);
    return (
        <button
            className={`w-10 h-10 flex items-center justify-center ${!isActive && "hover:bg-irGray-100 dark:hover:bg-darkSurface-300"} ${
                isActive ? "bg-irGray-200" : "bg-transparent"
            } rounded-lg`}
            onClick={handleClick}
        >
            <UnderlineIcon />
        </button>
    );
};
